import { useNavigate } from 'react-router-dom'
import logo from '../../assets/logo.png'

const Header = () => {
  const navigate=useNavigate()
  return (
    <nav className="w-full bg-white shadow-sm px-4 py-3 sticky top-0 z-50">
      <div className="p-4 flex items-center gap-4 w-full">
        <div className="cursor-pointer" onClick={()=>navigate('/home')}>
          <img
            src={logo}
            className="w-full max-w-[150px] object-contain"
            alt="Logo"
          />
        </div>
      </div>
    </nav>
  )
}

export default Header
